module.exports = __webpack_public_path__ + "static/media/image-13-full.009b2b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-13-full.jpg
// module id = 353
// module chunks = 0